export default __webpack_public_path__ + "static/media/logo-scc-min.6cfcbe7e.svg";